import { createTheme } from "@mui/material/styles";

const typographyPrimaryFontColor: string = "#6b7280";

export const theme = createTheme({
  typography: {
    fontFamily: '"Inter", sans-serif',
  },

  palette: {
    text: {
      primary: typographyPrimaryFontColor,
    },
  },
});
